/* Par From Home · Yardage Book
   Setup picker, add-on, AJAX add to cart into Dawn's cart drawer, sticky add to cart,
   product gallery and the mobile menu. */
(function () {
  'use strict';

  // Root-relative on purpose: the Klaviyo add-to-cart script in the header group
  // only fires for responses from exactly <origin>/cart/add.js.
  var ADD_URL = '/cart/add.js';
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  // The Klaviyo script reads a global `item`; make sure it always exists.
  if (typeof window.item === 'undefined') window.item = {};

  // Shared with assets/yb-upsell.js.
  window.YB = window.YB || {};

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function setText(sel, text, root) {
    qsa(sel, root).forEach(function (el) {
      el.textContent = text;
    });
  }
  function setHidden(sel, hidden, root) {
    qsa(sel, root).forEach(function (el) {
      el.hidden = !!hidden;
    });
  }

  /* ---------- Cart ---------- */
  function getDrawer() {
    var drawer = document.querySelector('cart-drawer');
    return drawer && typeof drawer.renderContents === 'function' ? drawer : null;
  }

  function goToCart() {
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function renderDrawer(state) {
    var drawer = getDrawer();
    if (!drawer) {
      goToCart();
      return;
    }
    var wasOpen = drawer.classList.contains('active');
    drawer.classList.remove('is-empty');
    drawer.renderContents(state);
    if (wasOpen) {
      // The drawer was already open, so no transition fires: put focus back inside it.
      setTimeout(function () {
        var container = document.getElementById('CartDrawer');
        var target = drawer.querySelector('.drawer__inner');
        if (typeof window.trapFocus === 'function' && container && target) {
          window.trapFocus(container, target);
        }
      }, 80);
    }
  }

  function fetchSections() {
    return fetch(window.location.pathname + '?sections=' + SECTIONS.join(','), {
      credentials: 'same-origin',
    }).then(function (res) {
      return res.json();
    });
  }

  // options.drawer === false: just add (the caller is heading to checkout).
  // options.beforeRender: runs right before the drawer opens (the upsell popup closes itself here).
  function addItems(items, options) {
    options = options || {};
    var drawer = getDrawer();
    var render = options.drawer !== false;
    var body = { items: items };
    if (drawer && render) {
      body.sections = SECTIONS.join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(function (json) {
          return { ok: res.ok, json: json };
        });
      })
      .then(function (result) {
        var json = result.json || {};
        if (!result.ok || json.status) {
          var error = new Error(json.description || json.message || 'Something went wrong. Please try again.');
          error.isCartError = true;
          throw error;
        }
        if (!render) return json;
        if (!drawer) {
          goToCart();
          return json;
        }
        if (typeof options.beforeRender === 'function') options.beforeRender();
        var sections = json.sections;
        if (sections && sections['cart-drawer'] && sections['cart-icon-bubble']) {
          try {
            renderDrawer(json);
          } catch (e) {
            goToCart();
          }
          return json;
        }
        return fetchSections()
          .then(function (fresh) {
            renderDrawer({ sections: fresh });
          })
          .catch(goToCart)
          .then(function () {
            return json;
          });
      });
  }

  window.YB.addItems = addItems;

  // Buttons that add one variant straight to the cart (drawer upsell, quick adds).
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-yb-add]') : null;
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    var id = parseInt(button.getAttribute('data-yb-add'), 10);
    if (!id) return;
    var label = button.querySelector('[data-yb-label]') || button;
    var idle = label.textContent;
    var errorEl = button.parentElement ? button.parentElement.querySelector('[data-yb-add-error]') : null;
    if (errorEl) errorEl.hidden = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = button.getAttribute('data-yb-busy') || 'Adding…';
    addItems([{ id: id, quantity: 1 }]).catch(function (error) {
      button.setAttribute('aria-busy', 'false');
      label.textContent = idle;
      if (errorEl) {
        errorEl.textContent = (error && error.isCartError && error.message) || 'Could not add that. Please try again.';
        errorEl.hidden = false;
      }
    });
  });

  // Secondary add-to-cart buttons (sticky bar, closing band) press the main one.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-yb-submit]') : null;
    if (!trigger) return;
    var atc = document.querySelector('[data-yb-form] [data-yb-atc]');
    if (!atc) {
      var href = trigger.getAttribute('data-href');
      if (href) window.location.href = href;
      return;
    }
    event.preventDefault();
    if (atc.disabled || atc.getAttribute('aria-busy') === 'true') return;
    atc.click();
  });

  /* ---------- Setup picker + add to cart ---------- */
  function initBuy(root) {
    qsa('[data-yb-buy]', root).forEach(function (box) {
      if (box.__ybReady) return;
      var form = qs('[data-yb-form]', box);
      var dataEl = qs('[data-yb-tiers]', box);
      if (!form || !dataEl) return;
      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      box.__ybReady = true;

      var radios = qsa('input[data-yb-tier]', form);
      var addon = qs('input[data-yb-addon]', form);
      var idInput = qs('[data-yb-variant-input]', form);
      var atc = qs('[data-yb-atc]', form);
      var atcLabel = atc ? qs('[data-yb-label]', atc) || atc : null;
      var errorEl = qs('[data-yb-error]', box);

      function current() {
        var checked = radios.filter(function (radio) {
          return radio.checked;
        })[0];
        var key = checked ? checked.value : String(data.selected);
        return data.tiers[key] || data.tiers[String(data.selected)];
      }

      function hideError() {
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
      }

      function showError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
      }

      function update() {
        var tier = current();
        if (!tier) return;
        var withAddon = !!(addon && addon.checked && !addon.disabled);
        if (idInput) idInput.value = tier.id;

        radios.forEach(function (radio) {
          var label = radio.closest('.yb-tier');
          if (label) label.classList.toggle('is-selected', radio.checked);
        });

        setText('[data-yb-price]', tier.price, box);
        setText('[data-yb-compare]', tier.compare, box);
        setHidden('[data-yb-compare]', !tier.compare, box);
        setText('[data-yb-save]', tier.save, box);
        setHidden('[data-yb-save]', !tier.save, box);
        setText('[data-yb-installment]', withAddon ? tier.installmentAddon : tier.installment, box);
        setHidden('[data-yb-installment-row]', !(withAddon ? tier.installmentAddon : tier.installment), box);

        var label = tier.available ? data.atcLabel + ' · ' + (withAddon ? tier.totalAddon : tier.total) : data.soldOutLabel;
        if (atc && atc.getAttribute('aria-busy') !== 'true') {
          atcLabel.textContent = label;
          atc.disabled = !tier.available;
        }
        setText('[data-yb-total-label]', label);

        if (addon) {
          setText('[data-yb-addon-note]', tier.unlock ? data.addonNoteUnlock : data.addonNote, form);
        }

        // Spec lines limited to some products (the mat, the balls) follow the chosen setup.
        qsa('[data-yb-only]', box).forEach(function (el) {
          var ids = (el.getAttribute('data-yb-only') || '').split(/\s+/);
          el.hidden = ids.indexOf(String(tier.productId)) === -1;
        });

        setText('[data-yb-sticky-name]', tier.label);
        setText('[data-yb-sticky-title]', tier.productTitle);
        setText('[data-yb-sticky-price]', tier.price);
        setText('[data-yb-sticky-compare]', tier.compare);
        setHidden('[data-yb-sticky-compare-wrap]', !tier.compare);
        qsa('[data-yb-sticky-img]').forEach(function (img) {
          if (tier.image && img.getAttribute('src') !== tier.image) {
            img.removeAttribute('srcset');
            img.setAttribute('src', tier.image);
          }
        });

        if (tier.item) window.item = tier.item;
      }

      function setBusy(on) {
        if (!atc) return;
        atc.setAttribute('aria-busy', on ? 'true' : 'false');
        atc.disabled = !!on;
        qsa('[data-yb-submit]').forEach(function (button) {
          button.setAttribute('aria-busy', on ? 'true' : 'false');
        });
        if (on) {
          atcLabel.textContent = data.addingLabel;
        } else {
          update();
        }
      }

      form.addEventListener('change', function (event) {
        if (event.target.matches('[data-yb-tier], [data-yb-addon]')) {
          hideError();
          update();
        }
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!atc || atc.getAttribute('aria-busy') === 'true') return;
        var tier = current();
        if (!tier || !tier.available) return;
        var items = [{ id: parseInt(tier.id, 10), quantity: 1 }];
        var withAddon = !!(addon && addon.checked && !addon.disabled);
        if (withAddon) {
          items.push({ id: parseInt(addon.value, 10), quantity: 1 });
        }
        hideError();

        // The upsell popup (sections/yb-upsell.liquid) takes over when it has offers for this item.
        if (window.YBUpsell && typeof window.YBUpsell.open === 'function') {
          var opened = window.YBUpsell.open({
            main: {
              id: parseInt(tier.id, 10),
              productId: tier.productId,
              title: tier.productTitle,
              variantTitle: tier.variantTitle || '',
              image: tier.image,
              price: tier.priceCents,
              quantity: 1,
            },
            extras: withAddon
              ? [
                  {
                    id: parseInt(addon.value, 10),
                    productId: parseInt(addon.getAttribute('data-product-id'), 10),
                    title: addon.getAttribute('data-title'),
                    variantTitle: addon.getAttribute('data-variant-title') || '',
                    image: addon.getAttribute('data-image'),
                    price: parseInt(addon.getAttribute('data-price'), 10) || 0,
                    quantity: 1,
                  },
                ]
              : [],
          });
          if (opened) return;
        }

        setBusy(true);
        addItems(items)
          .then(function () {
            setBusy(false);
          })
          .catch(function (error) {
            setBusy(false);
            if (error && error.isCartError) {
              showError(error.message);
            } else {
              // Network trouble: fall back to Shopify's normal add-to-cart form post.
              form.submit();
            }
          });
      });

      box.__ybUpdate = update;
      update();
    });
  }

  /* ---------- Sticky add to cart ---------- */
  // Shown once the main button has scrolled above the screen, hidden again while the
  // closing band (which has its own button) is on screen. Reads positions on scroll
  // rather than using IntersectionObserver, which misses jumps past the button
  // (anchor links, scroll-to-top).
  function initSticky() {
    var bar = document.querySelector('[data-yb-sticky]');
    var atc = document.querySelector('[data-yb-form] [data-yb-atc]');
    if (!bar || !atc || bar.__ybReady) return;
    bar.__ybReady = true;
    var band = document.querySelector('[data-yb-cta-band]');
    var shown = null;
    var queued = false;

    function check() {
      queued = false;
      if (!atc.isConnected) return;
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var passed = atc.getBoundingClientRect().bottom < 0;
      var bandVisible = false;
      if (band && band.isConnected) {
        var rect = band.getBoundingClientRect();
        bandVisible = rect.top < viewport && rect.bottom > 0;
      }
      var show = passed && !bandVisible;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) {
        bar.removeAttribute('inert');
      } else {
        bar.setAttribute('inert', '');
      }
      document.body.classList.toggle('yb-sticky-on', show);
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(check);
    }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    check();
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    qsa('[data-yb-gallery]', root).forEach(function (gallery) {
      if (gallery.__ybReady) return;
      var track = qs('[data-yb-track]', gallery);
      if (!track) return;
      gallery.__ybReady = true;
      var slides = qsa('.yb-gallery__slide', track);
      var thumbs = qsa('[data-yb-thumb]', gallery);
      var dots = qsa('[data-yb-dot]', gallery);
      var count = qs('[data-yb-count]', gallery);
      var active = 0;

      function setActive(index) {
        active = index;
        thumbs.forEach(function (thumb, i) {
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
        if (count) count.textContent = index + 1 + ' / ' + slides.length;
      }

      function go(index) {
        index = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: index * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
        setActive(index);
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          go(i);
        });
      });

      var frame = 0;
      track.addEventListener(
        'scroll',
        function () {
          if (frame) return;
          frame = window.requestAnimationFrame(function () {
            frame = 0;
            var index = Math.round(track.scrollLeft / (track.clientWidth || 1));
            if (index !== active && index >= 0 && index < slides.length) setActive(index);
          });
        },
        { passive: true }
      );

      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          go(active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu(root) {
    qsa('[data-yb-menu]', root).forEach(function (menu) {
      if (menu.__ybReady) return;
      menu.__ybReady = true;
      var summary = qs('summary', menu);
      menu.addEventListener('toggle', function () {
        if (summary) summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
      });
      menu.addEventListener('click', function (event) {
        if (event.target.closest('a')) menu.removeAttribute('open');
      });
      menu.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && menu.open) {
          menu.removeAttribute('open');
          if (summary) summary.focus();
        }
      });
      document.addEventListener('click', function (event) {
        if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
      });
    });
  }

  function init(root) {
    root = root || document;
    initMenu(root);
    initGallery(root);
    initBuy(root);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // Restore labels and prices when the page comes back from the back/forward cache.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    qsa('[data-yb-buy]').forEach(function (box) {
      if (typeof box.__ybUpdate === 'function') box.__ybUpdate();
    });
  });
})();
